import angular from 'angular';

// This file's ONLY job is to create the module.
angular.module('eCareVault.common.services', []);